import { z } from "zod";

// ─── Category enum ────────────────────────────────────────────────────────────

export const NonInvoiceIncomingCategoryEnum = z.enum([
  "ZWROT_US",
  "ZWROT_ZUS",
  "KAUCJA_ZWROT",
  "PRZELEW_POZAFAKTUROWY",
  "PRZELEW_ZA_FAKTURE",
  "DO_WERYFIKACJI",
]);
export type NonInvoiceIncomingCategory = z.infer<typeof NonInvoiceIncomingCategoryEnum>;

// ─── POST /api/non-invoice-incoming/run ──────────────────────────────────────

export const RunNonInvoiceClassificationRequestSchema = z
  .object({
    statement_id: z.string().uuid().optional(),
    from_date: z.string().date().optional(),
    to_date: z.string().date().optional(),
    overwrite_existing: z.boolean().default(false),
  })
  .refine(
    (d) => !(d.from_date !== undefined || d.to_date !== undefined) || (d.from_date !== undefined && d.to_date !== undefined),
    { message: "from_date and to_date must both be present or both absent" }
  );
export type RunNonInvoiceClassificationRequest = z.infer<typeof RunNonInvoiceClassificationRequestSchema>;

// ─── PATCH /api/non-invoice-incoming/:id/category ────────────────────────────

export const PatchNonInvoiceCategoryRequestSchema = z.object({
  category: NonInvoiceIncomingCategoryEnum,
});
export type PatchNonInvoiceCategoryRequest = z.infer<typeof PatchNonInvoiceCategoryRequestSchema>;

// ─── POST /api/non-invoice-incoming/export/sheets ────────────────────────────

export const ExportNonInvoiceToSheetsRequestSchema = z
  .object({
    from: z.string().date(),
    to: z.string().date(),
  })
  .refine((d) => d.from <= d.to, { message: "`to` must be >= `from`" });
export type ExportNonInvoiceToSheetsRequest = z.infer<typeof ExportNonInvoiceToSheetsRequestSchema>;

// ─── GET /api/non-invoice-incoming (query params) ────────────────────────────

export const NonInvoiceIncomingListQuerySchema = z.object({
  category: NonInvoiceIncomingCategoryEnum.optional(),
  from: z.string().date().optional(),
  to: z.string().date().optional(),
  statement_id: z.string().uuid().optional(),
  invoice_id: z.string().uuid().optional(),
  match_status: z.enum(["unmatched", "manual"]).optional(),
});
export type NonInvoiceIncomingListQuery = z.infer<typeof NonInvoiceIncomingListQuerySchema>;

// ─── Response item with invoice match fields (feature 016) ───────────────────

export const NonInvoiceIncomingItemMatchFieldsSchema = z.object({
  invoice_id: z.string().uuid().nullable(),
  match_status: z.enum(["unmatched", "manual"]),
  matched_at: z.string().datetime().nullable(),
});
export type NonInvoiceIncomingItemMatchFields = z.infer<typeof NonInvoiceIncomingItemMatchFieldsSchema>;
